import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {PortalService} from "./services/portal.service";

/**
 * Error page in case there is no result from backend. User can restart advisor
 */
@Component({
  selector: 'app-advisor-errorpage',
  templateUrl: './advisor.errorpage.component.html'
})
export class AdvisorErrorpageComponent implements OnInit {

  /**
   * Restart advisor by clicking the button.
   */
  restartAdvisor: string = "/";

  /**
   * constructor
   * @param portalService
   * @param activatedRoute
   */
  constructor(private activatedRoute: ActivatedRoute, private portalService: PortalService) {
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    this.activatedRoute.data.subscribe(data => {
      if(data.hasOwnProperty('advisor')) {
        this.restartAdvisor += this.portalService.currentPortalId + '/' + data.advisor;
      }
    });
  }

}
